import axios from "axios";

export default function deleteHoliday({ id }) {
  return new Promise((resolve, reject) =>
    axios
      .delete(`/support/api/v1/admin/business-holidays/${id}`)
      .then((response) => resolve({ ...response.data, id }))
      .catch((error) => reject(error.message))
  );
}
